module.exports = __webpack_public_path__ + "img/Print-icon.956cebd4.svg";